import React, { useEffect, useMemo, useState } from 'react';

import ImageChip from './chips/ImageChip';
import FileChip from './chips/FileChip';
import formatBytes from '../../../../utils/formatBytes';

export default function AttachmentChip({ item, onRemove }) {
  const file = item?.file;

  const [meta, setMeta] = useState({});

  const handleImageLoadingError = () => {
    setMeta((prev) => ({
      ...prev,
      kind: TYPES.FILE,
    }));
  };

  const handleRemove = () => {
    onRemove?.(item?.id);
  };

  useEffect(() => {
    const kind = item?.kind || detectType(file);
    setMeta({
      kind,
      name: item?.name || file?.name || 'File',
      size: formatBytes(item?.size ?? file?.size, true),
    });
  }, [item, file]);

  if (meta.kind === TYPES.IMAGE) {
    return <ImageChip onRemove={handleRemove} file={file} onError={handleImageLoadingError} />;
  }

  if (meta.kind === TYPES.FILE) {
    return <FileChip onRemove={handleRemove} name={meta.name} size={meta.size} />;
  }

  return null;
}

function detectType(file) {
  const type = file?.type || '';
  if (type.startsWith('image/')) return TYPES.IMAGE;
  if (type.startsWith('video/')) return TYPES.FILE;
  if (type === 'application/pdf') return TYPES.FILE;
  if (type.includes('word') || type.includes('officedocument.wordprocessingml') || type === 'application/msword')
    return TYPES.FILE;
  if (type.includes('excel') || type.includes('officedocument.spreadsheetml') || type === 'application/vnd.ms-excel')
    return TYPES.FILE;
  if (type.includes('powerpoint') || type.includes('officedocument.presentationml')) return TYPES.FILE;

  return TYPES.FILE;
}

const TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  PDF: 'pdf',
  DOC: 'doc',
  XLS: 'xls',
  PPT: 'ppt',
  FILE: 'file',
};
